import ModalFactory from '../factory';

import Content from './EmailPreviewModal';

const EmailPreviewModal = ModalFactory(Content);

export default EmailPreviewModal;
